// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"09854b38","729":"b6ca9f7c"}[chunkId] + ".css";
};